import { t } from "@/i18n-js/instance";
import { Link } from "react-router-dom";
import { Icon } from "@/react/components/shared/Icon";
import { MinimalProgressBar } from "@/react/components/shared/uikit/MinimalProgressBar";
import { communitiesPaths } from "@/react/helpers/routerPathHelpers";
import { useChecklist } from "@/react/hooks/useChecklist";
import { useSmScreenMediaQuery } from "@/react/hooks/useMediaQuery";
import { Typography } from "@circle-react-uikit/Typography";

const localeRoot = "community_onboarding.new_checklist.setup_checklist";
const compactLocaleRoot = "admin_dashboard.getting_started";

export interface CheckListProgressProps {
  variant?: "default" | "compact";
}

export const CheckListProgress = ({
  variant = "default",
}: CheckListProgressProps) => {
  const { progress, completedSteps, totalSteps } = useChecklist();
  const isSmallScreen = useSmScreenMediaQuery();

  if (variant === "compact") {
    return (
      <div className="border-primary border-b px-6 py-4">
        <div className="mb-3 flex items-center justify-between">
          <Typography.LabelMd weight="semibold">
            {t(`${compactLocaleRoot}.title`)}
          </Typography.LabelMd>
          <Link
            to={communitiesPaths.onboarding()}
            className="text-default hover:text-dark flex items-center gap-1 text-sm font-medium transition-colors"
          >
            {t(`${compactLocaleRoot}.tasks_completed`, {
              completedSteps,
              totalSteps,
            })}
            <Icon type="16-chevron-right" size={16} />
          </Link>
        </div>
        <MinimalProgressBar progress={progress} size="sm" />
      </div>
    );
  }

  return (
    <div className="border-primary border-b px-8 py-6">
      <div className="mb-3 flex items-center justify-between">
        {isSmallScreen ? (
          <Typography.LabelSm
            weight="semibold"
            textTransform="text-left"
            leading="leading-5"
          >
            {t(`${localeRoot}.indicator.setup_checklist`)}
          </Typography.LabelSm>
        ) : (
          <Typography.LabelMd weight="semibold">
            {t(`${localeRoot}.indicator.setup_checklist`)}
          </Typography.LabelMd>
        )}

        {isSmallScreen ? (
          <Typography.BodySm
            weight="semibold"
            textTransform="text-right"
            leading="leading-5"
          >
            {t(`${localeRoot}.indicator.tasks_completed`, {
              completedSteps,
              totalSteps,
            })}
          </Typography.BodySm>
        ) : (
          <Typography.BodyMd weight="semibold">
            {t(`${localeRoot}.indicator.tasks_completed`, {
              completedSteps,
              totalSteps,
            })}
          </Typography.BodyMd>
        )}
      </div>
      <div>
        <MinimalProgressBar progress={progress} size="sm" />
      </div>
    </div>
  );
};
